import { stage } from './environment';

export enum toggleNames {
  REGISTRATION = 'registration',
  FAMILY_REGISTRATION = 'familyRegistration',
  EVENT_REGISTRATION_WEEKS = 'eventRegistrationWeeks',
  COVID = 'covid',
  ACCOUNT = 'account',
  SMS = 'sms',
  ASC = 'allSchoolsChampionships',
  WC = 'winterChampionships',
  RR = 'rockettRelays',
  PAYMENTS = 'payments',
  SQUARE_PAYMENTS = 'squarePayments',
  FACEBOOK_SIGNIN = 'facebookSignIn',
  MAINTENANCE_MODE = 'maintenanceMode',
  GOOGLE_FORM = 'googleForm',
  V2 = 'v2',
}

type ToggleResponse = boolean | number;
export const toggles: { [key in toggleNames]: ToggleResponse } = {
  [toggleNames.ACCOUNT]: true, //stage !== 'production'
  [toggleNames.COVID]: false, //stage !== 'production'
  [toggleNames.REGISTRATION]: true, //stage !== 'production'
  [toggleNames.FAMILY_REGISTRATION]: false, //stage !== 'production'
  [toggleNames.EVENT_REGISTRATION_WEEKS]: stage === 'production' ? 2 : 52,
  [toggleNames.SMS]: false, //stage !== 'production'
  [toggleNames.ASC]: false,
  [toggleNames.RR]: false,
  [toggleNames.WC]: false,
  [toggleNames.PAYMENTS]: false,
  [toggleNames.SQUARE_PAYMENTS]: false,
  [toggleNames.FACEBOOK_SIGNIN]: false,
  [toggleNames.MAINTENANCE_MODE]: false,
  [toggleNames.GOOGLE_FORM]: true,
  [toggleNames.V2]: false
};

